// extracted by mini-css-extract-plugin
export default {"confirmAndPayButton":"UpgradeDowngradeButton_confirmAndPayButton__yfROz"};